import request from '@/sheep/request';

const OperationPayApi = {
  createOrder: (data) => {
    return request({
      url: '/operation/pay/order/create',
      method: 'POST',
      data,
      custom: {
        showLoading: true,
        showError: true,
      },
    });
  },
  submitOrder: (data) => {
    return request({
      url: '/operation/pay/order/submit',
      method: 'POST',
      data,
    });
  },
  getOrder: (orderId, sync) => {
    const params = { orderId };
    if (sync !== undefined) params.sync = sync;
    return request({
      url: '/operation/pay/order/get',
      method: 'GET',
      params,
      custom: {
        showLoading: false
      },
    });
  },
};

export default OperationPayApi;
